import { render, staticRenderFns } from "./JournalMaterialRequest.vue?vue&type=template&id=fdecd124"
import script from "./JournalMaterialRequest.vue?vue&type=script&lang=js"
export * from "./JournalMaterialRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports